import React, { useEffect, useState } from 'react';
import { AssetsTaskProps, PageType, TaskFieldType } from '../types';
import { useAsyncEffect, useSetState } from 'ahooks';
import {
  getTaskPage,
  getPageLowCode,
  getTaskPropertySettings,
} from '@/api/scene';
import { ROUTERSTATUSMAPPING } from './consts';
import { Empty, Spin, ConfigProvider } from 'antd';
import { getMaxFloor, Api as FetchAPI, isMobileEnv } from '@/utils';
import Cascade from '@/asset/AssetTask/templates/Cascade';
import { findAssetCascadeData, getTaskRules } from '@/api/cascade';
import { cascadeTransformValues } from './service';
import useMetaStore, { useMeta } from '@/store/useMetaStore';
import useValuesStore, { useValues } from '@/store/useValuesStore';
import { copyPageValue } from './templates/Cascade/effect/useCopyPage';
import StoreContext from '@/store/context';
import zhCN from 'antd/es/locale/zh_CN';
import { AbilityPoint, RuleTigger } from '@/const';
import { usePlatform, useStoreInit } from '@/effects';
import { Rule } from '@/store/type';
import { PageInitialization } from '@/utils/PageInitialization';
import RuleController from '@/components/RuleController';

function AssetTaskTem(props: AssetsTaskProps) {
  const {
    taskId,
    pageType,
    recordId,
    utils,
    pageConfig,
    onLoad,
    events,
    isMobile = isMobileEnv(),
    auth,
    propValues,
    formRef,
  } = props;
  (FetchAPI as any).headers = { taskId };
  // 与应用搭建平台通信
  usePlatform({ onLoad, props });
  const meta = useMetaStore();
  const { setRules, resetValue, values, pageRules } = useValuesStore();

  const { isReady } = useStoreInit({
    taskId,
    pageType,
    pageConfig,
    isMobile,
    utils,
    recordId,
    events,
    auth,
    propValues,
    formRef,
  });
  if (!isReady) {
    const spinStyles = {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'transparent',
    };
    return (
      <div style={spinStyles}>
        <Spin tip="Loading..." size="large" />
      </div>
    );
  }
  console.log('Values', values, pageRules);
  console.log('Meta', meta);
  // console.log('Rules', rules);
  if (recordId === '0' || Object.keys(meta.pageConfig || {}).length === 0) {
    return <Empty description="数据出现错误,请联系管理员处理" />;
  }
  let ability;
  if (pageType === PageType.Create) {
    ability = AbilityPoint.canCreate;
  } else if (pageType === PageType.Edit) {
    ability = AbilityPoint.canUpdate;
  } else if (pageType === PageType.Detail) {
    ability = AbilityPoint.canView;
  }
  return (
    <RuleController
      moduleCode={meta?.taskInfo?.mainModuleCode}
      ability={ability}
      displayUnauthorizedInfo
    >
      <Cascade />
    </RuleController>
  );
}

export default function StoreContextWarp(props: any) {
  const values = useValues();
  const meta = useMeta();
  return (
    <StoreContext.Provider value={{ values, meta }}>
      <ConfigProvider locale={zhCN}>
        <AssetTaskTem {...props} />
      </ConfigProvider>
    </StoreContext.Provider>
  );
}
